import Vue from 'vue'
import router from '@/router'
import axios from 'axios'
import store from '@/store'

const state = {
  authenticated: true || false,
  access_token: localStorage.getItem('access_token') || null,
  userInfo: JSON.parse(localStorage.getItem('user_info')) || null
}

const getters = {
  userInfo (state) {
    return state.userInfo
  }
}

const actions = {
  login ({commit}, data) {
    localStorage.setItem('access_token', data.token)
    commit('LOGIN', data)
    store.dispatch('check', data)
  },
  logout ({commit}, data) {
    commit('LOGOUT', data)
    store.dispatch('check', data)
  },
  register ({commit}, data) {
    commit('REGISTER', data)
  },
  check ({commit}, data) {
    const token = localStorage.getItem('access_token')
    if (token) {
      return new Promise((resolve, reject) => {
        axios.get('/auth/user', {
          headers: {
            Authorization: `Token ${token}`
          }
        })
          .then(res => {
            localStorage.setItem('userInfo', res.data.user)
            commit('CHECK', res.data.user)
            resolve()
            if (res.data.user && res.data.user.email_verified) {
              if (router.history.current.meta && !router.history.current.meta.auth && router.history.current.query && router.history.current.query.redirect === '/idc/cloud-server/create') {
                router.push({
                  path: '/cloud-server/create',
                  query: {cpu: router.history.current.query.cpu, ram: router.history.current.query.ram, disk: router.history.current.query.disk}
                })
              } else if (router.history.current.meta && router.history.current.meta.auth) {
                const cpu = JSON.parse(localStorage.getItem('cpu'))
                const ram = JSON.parse(localStorage.getItem('ram'))
                const disk = JSON.parse(localStorage.getItem('disk'))
                if (cpu && ram && disk) {
                  router.push({
                    path: '/cloud-server/create',
                    query: {cpu: cpu, ram: ram, disk: disk}
                  })
                }
              } else if (router.history.current.meta && !router.history.current.meta.auth && router.history.current.query && router.history.current.query.redirect !== '/idc/cloud-server/create') {
                // Xử lý redirect nếu có
                let callback_url = null
                if ('redirect' in router.history.current.query && (new RegExp('^https://portal.idconline.vn', 'g')).test(router.history.current.query.redirect)) {
                  callback_url = router.history.current.query.redirect
                }
                if (callback_url) {
                  window.location.href = callback_url
                } else if (location.pathname === '/idc/login') {
                  router.push({path: '/dashboard'})
                }
              }
              if (router.history.current.name === 'verify' || router.history.current.name === 'confirm-email') {
                router.push({path: '/dashboard'})
              }
            } else if (res.data.user && !res.data.user.email_verified && router.history.current.name !== 'verify') {
              router.push({path: '/verify'})
            }
            Vue.axios.defaults.headers['Authorization'] = `Token ${token}`
          })
          .catch(e => {
            if (e.response.status === 401 || !e.include('Network Error')) {
              window.localStorage.removeItem('access_token')
              router.push({ path: '/login' })
            }
            reject(e)
          })
      })
    } else {
      state.authenticated = false
      state.userInfo = null
      setTimeout(function () {
        if (router.history.current.meta.auth === true) {
          router.push({path: '/login'})
        }
      }, 1000)
    }
  }
}

const mutations = {
  LOGIN (state, data) {
    state.authenticated = true
    state.access_token = data.token
    Vue.axios.defaults.headers['Authorization'] = `Token ${data.token}`
  },
  LOGOUT (state, data) {
    state.authenticated = false
    state.access_token = null
    state.userInfo = null
    localStorage.clear()
    location.reload()
  },
  CHECK (state, data) {
    state.authenticated = true
    state.userInfo = data
  },
  REGISTER (state, data) {
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js